(function () {
  if (window.__brandCarouselInit) return;
  window.__brandCarouselInit = true;

  var mq = window.matchMedia('(max-width: 989px)');

  function clamp(v, min, max) {
    return v < min ? min : (v > max ? max : v);
  }

  function addSwipe(el, onSwipe) {
    var x0 = null, y0 = null, locked = false;
    function down(e) {
      if (e.button) return;
      x0 = e.clientX; y0 = e.clientY; locked = false;
      try { el.setPointerCapture(e.pointerId); } catch (err) {}
    }
    function mv(e) {
      if (x0 === null) return;
      var dx = e.clientX - x0, dy = e.clientY - y0;
      if (!locked && Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy)) locked = true;
    }
    function up(e) {
      if (x0 === null) return;
      var dx = e.clientX - x0;
      x0 = null;
      if (locked && Math.abs(dx) > 40) onSwipe(dx < 0 ? 1 : -1);
      locked = false;
    }
    function cancel() { x0 = null; locked = false; }
    el.addEventListener('pointerdown', down);
    el.addEventListener('pointermove', mv);
    el.addEventListener('pointerup', up);
    el.addEventListener('pointercancel', cancel);
    return function () {
      el.removeEventListener('pointerdown', down);
      el.removeEventListener('pointermove', mv);
      el.removeEventListener('pointerup', up);
      el.removeEventListener('pointercancel', cancel);
    };
  }

  function measureFactory(track, refGetter, root) {
    return function () {
      var ref = refGetter();
      var slideW = ref.offsetWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return { step: slideW + gap, slideW: slideW, viewport: root.clientWidth };
    };
  }

  function enableFinite(ctx) {
    var root = ctx.root, track = ctx.track, slides = ctx.originals, n = slides.length;
    var prev = root.querySelector('[data-bc-prev]');
    var next = root.querySelector('[data-bc-next]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-bc-dot]'));
    var pointer = 0;
    var animating = false;
    var measure = measureFactory(track, function () { return slides[0]; }, root);

    function render(animate) {
      var m = measure();
      var offset = (m.viewport - m.slideW) / 2 - pointer * m.step;
      track.style.transition = animate ? '' : 'none';
      track.style.transform = 'translateX(' + offset + 'px)';
      if (!animate) { void track.offsetHeight; track.style.transition = ''; }
      slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === pointer); });
      dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === pointer); });
      if (prev) prev.disabled = pointer === 0;
      if (next) next.disabled = pointer === n - 1;
    }

    function go(index) {
      var target = clamp(index, 0, n - 1);
      if (target === pointer) return;
      pointer = target;
      render(true);
    }

    var onPrev = function () { if (!animating) go(pointer - 1); };
    var onNext = function () { if (!animating) go(pointer + 1); };
    if (prev) prev.addEventListener('click', onPrev);
    if (next) next.addEventListener('click', onNext);

    var dotHandlers = [];
    dots.forEach(function (dot, i) {
      var h = function () { if (!animating) go(i); };
      dot.addEventListener('click', h);
      dotHandlers.push([dot, h]);
    });

    var onStart = function () { animating = true; };
    var onEnd = function (e) { if (e.propertyName === 'transform') animating = false; };
    track.addEventListener('transitionstart', onStart);
    track.addEventListener('transitionend', onEnd);

    var removeSwipe = addSwipe(track, function (dir) { if (!animating) go(pointer + dir); });

    var rt;
    var onResize = function () { clearTimeout(rt); rt = setTimeout(function () { render(false); }, 150); };
    window.addEventListener('resize', onResize);

    ctx.teardown = function () {
      if (prev) { prev.removeEventListener('click', onPrev); prev.disabled = false; }
      if (next) { next.removeEventListener('click', onNext); next.disabled = false; }
      dotHandlers.forEach(function (p) { p[0].removeEventListener('click', p[1]); });
      track.removeEventListener('transitionstart', onStart);
      track.removeEventListener('transitionend', onEnd);
      removeSwipe();
      window.removeEventListener('resize', onResize);
      track.style.transform = '';
      track.style.transition = '';
      slides.forEach(function (s) { s.classList.remove('is-active'); });
      dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === 0); });
    };

    render(false);
  }

  function enableLoop(ctx) {
    var root = ctx.root, track = ctx.track, originals = ctx.originals, n = originals.length;
    var prev = root.querySelector('[data-bc-prev]');
    var next = root.querySelector('[data-bc-next]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-bc-dot]'));
    var measure = measureFactory(track, function () {
      return track.querySelector('[data-bc-slide]') || originals[0];
    }, root);

    var m = measure();
    var perView = Math.max(1, Math.ceil(m.viewport / m.step));
    var copies = Math.max(5, perView * 2 + 3);

    track.innerHTML = '';
    var all = [];
    for (var c = 0; c < copies; c++) {
      for (var i = 0; i < n; i++) {
        var clone = originals[i].cloneNode(true);
        clone.removeAttribute('id');
        clone.setAttribute('data-real', String(i));
        track.appendChild(clone);
        all.push(clone);
      }
    }

    var base = Math.floor(copies / 2) * n;
    var pointer = base;
    var animating = false;

    function render(animate) {
      m = measure();
      var offset = (m.viewport - m.slideW) / 2 - pointer * m.step;
      track.style.transition = animate ? '' : 'none';
      track.style.transform = 'translateX(' + offset + 'px)';
      if (!animate) { void track.offsetHeight; track.style.transition = ''; }
      var real = ((pointer % n) + n) % n;
      all.forEach(function (s, idx) { s.classList.toggle('is-active', idx === pointer); });
      dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === real); });
    }

    function normalize() {
      if (pointer < n) { pointer += n; render(false); }
      else if (pointer >= all.length - n) { pointer -= n; render(false); }
    }

    function move(dir) {
      if (animating) return;
      animating = true;
      pointer += dir;
      render(true);
    }

    var onEnd = function (e) {
      if (e.propertyName !== 'transform') return;
      animating = false;
      normalize();
    };
    track.addEventListener('transitionend', onEnd);

    var onPrev = function () { move(-1); };
    var onNext = function () { move(1); };
    if (prev) prev.addEventListener('click', onPrev);
    if (next) next.addEventListener('click', onNext);

    var dotHandlers = [];
    dots.forEach(function (dot, i) {
      var h = function () {
        if (animating) return;
        var real = ((pointer % n) + n) % n;
        var diff = i - real;
        if (diff === 0) return;
        animating = true;
        pointer += diff;
        render(true);
      };
      dot.addEventListener('click', h);
      dotHandlers.push([dot, h]);
    });

    var removeSwipe = addSwipe(track, function (dir) { move(dir); });

    var rt;
    var onResize = function () { clearTimeout(rt); rt = setTimeout(function () { render(false); }, 150); };
    window.addEventListener('resize', onResize);

    ctx.teardown = function () {
      track.removeEventListener('transitionend', onEnd);
      if (prev) prev.removeEventListener('click', onPrev);
      if (next) next.removeEventListener('click', onNext);
      dotHandlers.forEach(function (p) { p[0].removeEventListener('click', p[1]); });
      removeSwipe();
      window.removeEventListener('resize', onResize);
      track.style.transform = '';
      track.style.transition = '';
      track.innerHTML = '';
      originals.forEach(function (o) { o.classList.remove('is-active'); track.appendChild(o); });
      dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === 0); });
    };

    render(false);
  }

  function enable(ctx) {
    if (ctx.enabled) return;
    if (ctx.loop) enableLoop(ctx);
    else enableFinite(ctx);
    ctx.enabled = true;
  }

  function disable(ctx) {
    if (!ctx.enabled || !ctx.teardown) return;
    ctx.teardown();
    ctx.teardown = null;
    ctx.enabled = false;
  }

  function apply(ctx) {
    if (mq.matches) enable(ctx);
    else disable(ctx);
  }

  function setup(root) {
    if (root.__bc) { apply(root.__bc); return; }
    var track = root.querySelector('[data-bc-track]');
    if (!track) return;
    var originals = Array.prototype.slice.call(track.querySelectorAll('[data-bc-slide]'));
    if (originals.length < 2) return;
    var ctx = {
      root: root,
      track: track,
      originals: originals,
      loop: root.hasAttribute('data-bc-loop'),
      enabled: false,
      teardown: null
    };
    root.__bc = ctx;
    apply(ctx);
  }

  function applyAll() {
    document.querySelectorAll('[data-brand-carousel]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyAll);
  } else {
    applyAll();
  }

  if (mq.addEventListener) mq.addEventListener('change', applyAll);
  else if (mq.addListener) mq.addListener(applyAll);

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-brand-carousel]').forEach(setup);
  });
})();
